// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';

// Hooks
import useLoadData from '../../hooks/useLoadData';

function RouterComponent({ Component, path, componentName, ...rest }) {
  useLoadData(componentName);

  return <Route path={path} {...rest} render={(props) => <Component {...props} />} />;
}

RouterComponent.propTypes = {
  Component: PropTypes.elementType.isRequired,
  componentName: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default withRouter(RouterComponent);
